import { FC, ReactNode } from "react";
import { Fieldset, FieldsetProps } from "./Fieldset";
import { CustomCSSProperties, IconName } from "../../types";
import { Icon } from "../Icon";

export interface SelectionItem {
    id: number | string
    value?: string
    icon?: IconName 
    disabled?: boolean
    tooltipText?: string 
}

interface SelectionProps extends FieldsetProps {
    selectionItems: SelectionItem[]
    value: string | number
    children?: ReactNode
    onSelection: (clickedItem: SelectionItem) => unknown
}

export const Selection:FC<SelectionProps> = ({selectionItems, onSelection, value, children, ...rest}) => {

    return (
        <Fieldset {...rest}>
            <div 
                className="selection-list df aic jcsb w-100"
            >
            {
                selectionItems.map((selectionItem, index) => {

                    const isSelected = value === selectionItem.id

                    return (
                        <button 
                            type="button"
                            disabled={selectionItem.disabled}
                            id={selectionItem.value}
                            key={index}
                            style={{'--index': index} as CustomCSSProperties}
                            aria-pressed={isSelected ? 'true' : 'false'}
                            aria-label={selectionItem.value}
                            className={`button r3 b-0 py-3 px-0 selection-list-item outline-shadow tooltip-container p-r w-100 ${selectionItem.id === value ? 'selected' : ''} ${index !== 0 ? 'ml-5' : ''}`}
                            onClick={() => onSelection(selectionItem)}
                        >
                            { selectionItem.disabled && (<span className="text nw sold-out">Sold out</span>)}
                            { selectionItem.value && (<span className="text s18-500 value" aria-hidden>{selectionItem.value}</span>)}
                            { selectionItem.icon && !selectionItem.disabled && <Icon icon={selectionItem.icon} aria-hidden/>}
                        </button>
                    )
                })
            }
            </div>
            {children}
        </Fieldset>
    )
}
